export default __webpack_public_path__ + "static/media/calendar_Small.e2e5ef3d.svg";